/**
 * base class for all types of requests
 */
import { GenericValue } from 'hisng';
import { Person } from 'app/fs/res/common/model/person/person';

export class RequestBase {
    applicant: Person;
    applicantRole: GenericValue;

    reasonableReqType: GenericValue;
    approvalStatusValue: GenericValue;
    processingStatusValue: GenericValue;
    receiptdate: string | Date;

    changedate: string | Date;
    inboxdate: string | Date;
    signdate: string | Date;
    reasonForRejection: any[];
    commentaryInternal: string;
    commentaryApplicant: string;
    commentaryStatus: string;

    declarations: Declaration[];
}

export class Declaration {
    id: number;
    declarationDefiniton: GenericValue;
    // per object only one of the following attributes is set
    checkboxValue?: GenericValue;
    textfieldValue?: string;
}
